import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { URL,api } from '../../api';

export default class Modalexpercommentbacktex extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",

   evaluation:[],//


   id_send:"",//
   id_excomment:"",//
   id_ex:"",//
   statuscomment_ex:"", //
   filewordcomment_ex:null,
   filepdfcomment_ex:null,//
   comment_ex:"",//
   filevalue:'0',

   totalall:0,
}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.setgrade = this.setgrade.bind(this);
this.setgrade2 = this.setgrade2.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_ex: event.target.value});  }


setgrade = index => evt => {
  console.log(evt.target.value)
  console.log(index)
  if (evt.target.value === '1' || evt.target.value === '2' || evt.target.value === '3' || evt.target.value === '4' || evt.target.value === '5' || evt.target.value === '6' || evt.target.value === '7' || evt.target.value === '8' || evt.target.value === '9' || evt.target.value === '10'|| evt.target.value === '0' || evt.target.value === '') {
      const newShareholders = this.state.evaluation.map((evaluation, sidx) => {
          if (index !== sidx) return evaluation;
          return { ...evaluation, scool: Number(evt.target.value) };
        });
       console.log(newShareholders)
        this.setState({ evaluation: newShareholders });

        const total = newShareholders.reduce(
          (total, currentItem) => (total = total + Number(currentItem.scool)),
          0
        );

        this.setState({ totalall: total });


  }else{
      Swal.fire({
          title: 'ท่านกรอกคะแนนไม่ตรงตามเกณฑ์ที่กำหนด',
          icon: 'success',
        // showCancelButton: true,
          confirmButtonText: 'ตกลง',
        // cancelButtonText: 'No, keep it'
        }).then((result) => {
        
        })

  }
}

setgrade2 = index => evt => {
  const newShareholders = this.state.evaluation.map((evaluation, sidx) => {
    if (index !== sidx) return evaluation;
    return { ...evaluation, commentevaluation: evt.target.value };
  });
console.log(newShareholders)
  this.setState({ evaluation: newShareholders });
}

 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
        this.setState({ id_send:this.props.id_send,
                       id_excomment:this.props.id_excomment,
                       id_ex:this.props.id_ex,
        })
    //   this.setState({ id_bn:this.props.expert_id})
      setTimeout(() => {
        //ภายใน
        api.get('registercon/selectevaluation/'+this.props.id_send+'/'+this.props.id_ex)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ evaluation: res.data})
          // const reformattedArray = res.data.map(({  value }) => ({ 
          //   [key]: value 
          // }));
        }) 
      }, 0);
  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
      api.get('registercon/selectevaluation')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
      this.setState({ evaluation: res.data})
      }) 

    }, 0);

}

  handleChange(event) {    this.setState({statuscomment_ex: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({filewordcomment_ex: event.target.files[0]});  }
  handleChange3(event) {    
    this.setState({filepdfcomment_ex: event.target.files[0]}); 
    this.setState({filevalue: '1'}); 
  
  }




  handleSubmit= (e) => {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

    const evaluationlist = this.state.evaluation;
    const result = this.state.evaluation.filter((word) => word.scool != '' && word.commentevaluation != '');

    console.log(result.length)
    console.log(this.state.evaluation.length)
    console.log(this.state.statuscomment_ex)
     console.log(this.state.filepdfcomment_ex)
    if (result.length === this.state.evaluation.length) {

      
                  if (this.state.statuscomment_ex != '' ) {
                                  setTimeout(() => {
                              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                              datafrm.append("id_sendarticle", this.state.id_send);
                              datafrm.append("id_excomment", this.state.id_excomment);
                              datafrm.append("id_expertex", this.state.id_ex);
                              datafrm.append("comment_ex", this.state.comment_ex);
                              datafrm.append("statuscomment_ex", this.state.statuscomment_ex);
                              datafrm.append("date_senbackexpert", dates);
                          
                              datafrm.append("filepdfcomment_ex", this.state.filepdfcomment_ex);
                              datafrm.append("filevalue", this.state.filevalue);
                              datafrm.append("evaluation",JSON.stringify(evaluationlist));
                              
                                api.post("registercon/InsertArticleexmapexpert",datafrm,{   
                        
                                headers: {
                                    'content-type': 'multipart/form-data'
                                }
                            })
                          .then(res => {
                          
                                    if (res.data ==='200') {
                                        Swal.fire({
                                        title: 'บันทึกข้อเสนอแนะสำเร็จ',
                                        text: "Suggestion saved successfully",
                                        icon: 'success',
                                        showCancelButton: false,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'ตกลง'
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                            this.getExpert()
                                            this.props.list()
                                            this.toggle()

                                        }
                                      })
                                      
                                      }else{
                                            message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                                      }
                              })
                            }, 1000);
                  } else {
                    Swal.fire({
                      title: 'ท่านยังไม่ได้แจ้งสถานะบทความ',
                      text: "ตรวจสอบการแจ้งสถานะ",
                      icon: 'warning',
                      showCancelButton: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'ตกลง'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        //  this.props.list()
                        // this.toggle()
                      }
                    })
                  }
    
     



        } else {
          Swal.fire({
            title: 'ท่านเพิ่มคะแนนไม่ครบ',
            text: "ตรวจสอบการเพิ่มข้อมูล",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง'
          }).then((result) => {
            if (result.isConfirmed) {
              //  this.props.list()
               // this.toggle()
            }
          })
        }




  }



  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.state.id_send);
      datafrm.append("id_comment", this.state.id_comment);
      datafrm.append("id_ex", this.state.id_ex);
      datafrm.append("statuscomment_bn", this.state.statuscomment_bn);
      
  Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadcommentbnbackpass.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data.status = 'success999') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }

  

    render() {

   //   console.log(this.state.evaluation)
      // const total = this.state.evaluation.reduce(
      //   (total, currentItem) => (total = total + Number(currentItem.scool)),
      //   0
      // );
     // console.log(total)

        return (
            <>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>ประเมินบทความ</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>
              แบบประเมินและข้อเสนอแนะ
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <form 
                onSubmit={this.handleSubmit}
                 >
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
                        <p className="font-weight-bold">ชื่อบทความ : {this.props.name_article}</p>
                        
                        {/* <p className="font-weight-bold">2.รายละเอียดการประเมินเบื้องต้น เลือกคะแนนและ <br/>ให้ข้อเสนอะแนะ</p> */}
                        {/* <p>2.รายละเอียดการประเมินเบื้องต้น โดยคะแนน 1 – 10 <br/>แสดงถึง เห็นด้วยน้อยที่สุด – มากที่สุด</p> */}
                          <MDBTable bordered small>
                          <MDBTableHead color="stylish-color" textWhite>
                                    <tr>
                                      <th>ลำดับ</th>
                                      <th  style={{ width: 200 }}>หัวข้อประเมิน</th>
                                      <th style={{ width: 200 }}>คะแนน 1 - 5 </th>
                                      <th>ข้อเสนอแนะ</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {this.state.evaluation.map((evaluation,index) =>{ 
                                       
                                    return  <tr>
                                                <td>{index+1}</td>
                                                <td>{evaluation.evaluation_nema	}</td>
                                               
                                                <td>
                                                    <div key={evaluation.id_evaluation} className="input-group">
                                                        {/* <input type="number"
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade(index)} value={evaluation.scool} /> */}
                                                              <select className="browser-default custom-select" onChange={this.setgrade(index)}  value={evaluation.scool} required>
                                                                          <option>--กรุณาเลือกคะแนน---</option>
                                                                          <option value="1" >1 คะแนน</option>
                                                                          <option value="2" >2 คะแนน</option>
                                                                          <option value="3" >3 คะแนน</option>
                                                                          <option value="4" >4 คะแนน</option>
                                                                          <option value="5" >5 คะแนน</option>
                                                              </select>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div key={evaluation.id_evaluation} className="input-group">
                                                        <textarea type="textarea"
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade2(index)} value={evaluation.commentevaluation}  />
                                                           
                                                              {/* <select className="browser-default custom-select" onChange={this.setgrade(index)} >
                                                                          <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                                                          <option value="1" >เห็นควร</option>
                                                                          <option value="2" >เห็นควร</option>
                                                              </select> */}
                                                    </div>
                                                </td>
                                            </tr>
                                    } )}
                                   
                                    
                                </MDBTableBody>
                             </MDBTable>

              <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" type='text'  onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุข้อเสนอแนะ"  />
              </div>


            

              {/* <p>อัพโหลดไฟล์แบบประเมิน .word</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}

                    {/* <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมินบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                     </div> */}

                     <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์ข้อเสนอแนะบทความ <MDBIcon icon="file-pdf" /> .pdf (ถ้ามี)</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        
                                    />
                     </div>

                        <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label><label className="red-text">*</label>
                <select className="browser-default custom-select" onChange={this.handleChange} required>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="1">ยอมรับให้เข้าร่วมนำเสนอ โดยไม่มีการแก้ไข</option>
                        <option value="2">ยอมรับให้เข้าร่วมนำเสนอ โดยให้มีการแก้ไข(ตามคำแนะนำ)</option>
                        <option value="0">ปฎิเสธการเข้าร่วมนำเสนอ</option>
                </select>
                </div>
         
                   {/* <h3 className='text-center'>คะแนน {total}/50</h3>    */}
             <h3 className='text-center mt-2'>คะแนน {this.state.totalall}/50</h3>   
              </div>
              <div className='text-center'>
                 <MDBBtn color="primary" type='submit'>บันทึก</MDBBtn>
                 <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              </div>
              

              </form>
              </MDBModalBody>

             
              <MDBModalFooter>
              {/* {this.state.filewordcomment_ex !== null  && this.state.filepdfcomment_ex !== null  ? <><MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> </> :<> <MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> } */}
              {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn> */}
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


